import { useRef } from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogFooter,
  Button,
  Heading,
  Text,
  VStack,
  HStack,
  StackDivider,
} from '@chakra-ui/react';

import { useTranslation, Trans } from 'react-i18next';

type CancelAlertDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

// 取消訂單彈出視窗 （純顯示）
export default function CancelAlertDialog({ isOpen, onClose, onConfirm }: CancelAlertDialogProps) {
  const cancelRef = useRef(null);
  const { t } = useTranslation();
  return (
    <AlertDialog
      size="sm"
      isOpen={isOpen}
      onClose={onClose}
      leastDestructiveRef={cancelRef}
      isCentered
    >
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogBody my={6}>
          <VStack align="center">
            <Heading fontSize="lg">{t('store.order.cancelModal.title')}</Heading>
            <Trans i18nKey="store.order.cancelModal.note">
              <Text fontSize="sm"></Text>
              <Text fontSize="sm"></Text>
            </Trans>
          </VStack>
        </AlertDialogBody>

        <AlertDialogFooter p={0} borderColor="wsGray.300" borderTopWidth="1px">
          <HStack w="full" spacing={0} divider={<StackDivider />}>
            <Button
              variant="unstyled"
              fontWeight="normal"
              flex="1"
              ref={cancelRef}
              onClick={onClose}
            >
              {t('store.order.cancelModal.wait')}
            </Button>
            <Button variant="unstyled" fontWeight="normal" flex="1" onClick={onConfirm}>
              {t('store.order.cancelModal.confirm')}
            </Button>
          </HStack>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
